import React, { useEffect, useState } from "react";
import { Box, Tabs, Tab, Paper, Typography } from "@mui/material";
import {
  Divider,
  Grid,
  Button,
  Card,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  FormLabel,
  FormControl,
  TextField,
  InputAdornment,
  Container,
} from "@mui/material";
import _ from "lodash";
import { useForm } from "react-hook-form";

import CustomLayout from "views/CustomLayout";
import CustomBreadcrumbs from "components/Breadcrumbs";
import axiosInstance from "configs/axiosConfig";

import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Loader from "components/Loader";
import { APIRouteConstants } from "constants/routeConstants";
import { useSnackbar } from "notistack";

const UserSetting = ({ breadcrumbs }) => {
  const [openUpdatePass, setUpdatePass] = useState(false);
  const [activeCard, setActiveCard] = useState();
  const [openUpdateAdd, setUpdateAdd] = useState(false);
  const [userDetail, setUserDetail] = useState({});
  const [loader, setLoader] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const getUserDetails = async (category) => {
    setLoader(true);
    let res = await axiosInstance.get(
      APIRouteConstants.DASHBOARD.GET_USER_DETAIL,
    );
    let { data } = res;

    if (data && !_.isEmpty(data.data)) {
      setUserDetail(data.data);
    }
    setLoader(false);
  };

  const handleUpdatePassword = async (formData) => {
    setLoader(true);
    let res = await axiosInstance.post(
      APIRouteConstants.DASHBOARD.UPDATE_PASSWORD,
      formData,
    );
    let { data, response } = res;

    if (response && response.status == 400 && response.data) {
      enqueueSnackbar(response.data.message, { variant: "error" });
      reset();
    }

    if (!_.isEmpty(data)) {
      enqueueSnackbar("Password updated successfully", { variant: "success" });
      setUpdatePass(false);
      reset();
    }
    setLoader(false);
  };

  const [addressList, setAddressList] = useState([]);

  const getAddressList = async () => {
    let res = await axiosInstance.get(
      APIRouteConstants.DASHBOARD.GET_ADDRESS_LIST,
    );
    let { data, response } = res;

    if (response && response.status === 400 && response.data) {
      for (let i in response.data) {
        enqueueSnackbar(_.capitalize(i) + ": " + response.data[i][0], {
          variant: "error",
        });
        setLoader(false);
      }
    }

    if (data) {
      setAddressList(data);
    }
  };

  useEffect(() => {
    getUserDetails();
    getAddressList();
  }, []);

  return (
    <CustomLayout>
      <Loader open={loader} />
      <div className="content-container">
        <CustomBreadcrumbs
          list={breadcrumbs}
          name={
            _.get(userDetail, "first_name") +
            " " +
            _.get(userDetail, "last_name")
          }
        />
        <Divider className="divider" />
        <Container maxWidth="lg" disableGutters>
          <Box
            className="content-container"
            sx={{
              width: "100%",
              margin: "0 auto",
              px: { xs: 2, sm: 2, md: 3 },
              mt: {
                xs: "130px",
                md: "90px",
              },
            }}
          >
            <ContactTabs userDetail={userDetail} />
          </Box>
        </Container>
      </div>
    </CustomLayout>
  );
};

export default UserSetting;

function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

const ContactTabs = ({ userDetail }) => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };
  console.log("details", userDetail);
  return (
    <Grid elevation={3} sx={{ mt: 2, boxShadow: 2, p: 3, mb: 6 }}>
      <Box
        sx={{
          background: "#f9fafb",
          borderRadius: "16px",
          p: 1,
          mb: 3,
        }}
      >
        <Tabs
          value={tabIndex}
          onChange={handleChange}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          TabIndicatorProps={{
            sx: {
              height: "100%",
            
              borderRadius: "999px",
              backgroundColor: "#fff",
              boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
              border: "1px solid #000",
            },
          }}
          sx={{
            minHeight: "56px",
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 500,
              fontSize: "15px",
              zIndex: 1,
              minHeight: "48px",
            },
          }}
        >
          <Tab
            icon={<ContactEmergencyIcon />}
            iconPosition="start"
            label="Account"
            sx={{ textTransform: "capitalize" }}
          />
          <Tab
            icon={<LocationOnIcon />}
            iconPosition="start"
            label="Addresses"
            sx={{ textTransform: "capitalize" }}
          />
        </Tabs>
      </Box>

      {/* <TabPanel value={tabIndex} index={0}>
                <Grid container spacing={2} >
                    <Grid item xs={6} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary" >
                            First Name
                        </Typography>
                        <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>{userDetail.first_name}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                            Last Name
                        </Typography>
                        <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>{userDetail.last_name}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                            Email
                        </Typography>
                        <Typography variant="body1">{userDetail.email}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                            Contact
                        </Typography>
                        <Typography variant="body1">{`+${userDetail.country_code} ${userDetail.mobile_number}`}</Typography>
                    </Grid>
                </Grid>
            </TabPanel> */}
      <TabPanel value={tabIndex} index={0}>
        <Grid container spacing={2}>
          {/* First Name */}
          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle2">
              First Name:{" "}
              <span
                variant="body1"
                sx={{ textTransform: "capitalize" }}
                color="text.secondary"
              >
                {userDetail.first_name}
              </span>
            </Typography>
            <Typography variant="subtitle2">
              Email:{" "}
              <span variant="body1" color="text.secondary">
                {userDetail.email}
              </span>
            </Typography>
          </Grid>

          {/* Last Name */}
          <Grid item xs={12} sm={4}>
            <Typography variant="subtitle2">
              Last Name:{" "}
              <span variant="body1" color="text.secondary">
                {userDetail.last_name}
              </span>
            </Typography>
            <Typography variant="subtitle2">
              Contact :{" "}
              <span variant="body1" color="text.secondary">
                +{userDetail.country_code} {userDetail.mobile_number}
              </span>
            </Typography>
          </Grid>
        </Grid>
      </TabPanel>

            <TabPanel value={tabIndex} index={1}>

                <Typography variant="subtitle2" color={'GrayText'} gutterBottom>No address found.</Typography>
                <Typography variant="subtitle2" color={'GrayText'} gutterBottom>
                    Coming soon - You’ll be able to add or edit addresses.</Typography>
                {/* <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="subtitle2" color="text.secondary">
                            Street
                        </Typography>
                        <Typography variant="body1">{addressInfo.street}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                            City
                        </Typography>
                        <Typography variant="body1">{addressInfo.city}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                            Postal Code
                        </Typography>
                        <Typography variant="body1">{addressInfo.postalCode}</Typography>
                    </Grid>
                </Grid> */}
      </TabPanel>
    </Grid>
  );
};
